import { Flex, Text, Button } from "@chakra-ui/react";

export function PromoRibbion({
  focusPayment,
  bgColor = "yellow.500",
  textColor = "black",
  text = "Special promo! Unlock Apollyon + over 100,000 titles for one full year",
  ctaText = "Subscribe now"
}: {
  focusPayment: () => void;
  bgColor?: string;
  textColor?: string;
  text?: string | JSX.Element;
  ctaText?: string;
}) {
  return (
    <>
      <Flex
        padding="12px 24px"
        backgroundColor={bgColor}
        width="100%"
        gap="20px"
        justifyContent="center"
        alignItems="center"
        color={textColor}
      >
        <Text
          fontFamily="Bricolage Grotesque 24pt"
          fontSize="16px"
          fontWeight="600"
          lineHeight="130%"
          textAlign="center"
        >
          {text}
        </Text>
        <Button
          variant="tertiary"
          onClick={focusPayment}
          color={textColor}
          borderColor="transparent.charcoal.50"
          p="6px 16px"
          borderRadius="10px"
          boxShadow="0 8px 12px 0 rgba(0, 0, 0, 0.20)"
          minWidth="none"
        >
          {ctaText}
        </Button>
      </Flex>
    </>
  );
}
